export const dicsiplTypeToPrettyFormat = (data: string): string => {
  if (data === 'л.р.') {
    return 'Лабораторная работа';
  } else if (data === 'лек') {
    return 'Лекция';
  } else if (data === 'пр') {
    return 'Практика';
  } else {
    return data;
  }
};
